export const TASKS_LIST_QUERY_KEY = 'userTasksList';
